export default __webpack_public_path__ + "static/media/i003vp.6bee9de4.webp";